module.exports = __webpack_public_path__ + "static/media/pin.a5f9bad3.png";